import React from 'react'
import styled from 'styled-components'

const SubComponent = styled.tr<{ isOpen: boolean }>`
  background-color: transparent !important;
  box-shadow: none !important;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'collapse')};
  transition: visibility ease;
`

const Column = styled.div`
  position: relative;
  margin-right: 2px;
  min-width: 200px;

  :last-of-type {
    width: 100%;
  }
`

const Title = styled.div`
  font-weight: 600;
  height: 40px;
  background: #f8f8f8;
  margin-bottom: 2px;
  border-radius: 0 0 4px 4px;

  span {
    position: absolute;
    padding: 10px 20px;
  }
`

const TableCell = styled.td`
  position: relative;
  padding: 0 !important;
  background-color: transparent !important;
  border-top: 0 !important;
`

const Fields = styled.div`
  background: #f8f8f8;
  margin-bottom: 2px;
  border-radius: 4px;
  padding: 10px 20px;
`

const Field = styled.div`
  display: flex;
  margin-bottom: 10px;

  :last-of-type {
    margin-bottom: 0;
  }
`

const Content = styled.div`
  display: flex;
`
const Line = styled.div`
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 20px;
  top: -10px;
  background: #f8f8f8;
`

const FieldTitle = styled.div`
  width: 200px;
  color: ${({ theme }) => theme.colors.gray3};
`

const Description = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.gray1};
`

const MainTableCell = styled.td<{ first: boolean }>`
  display: ${({ first }) => first && 'flex !important'};
  align-items: center;
`

type Props = {
  rowData: any
  id?: string
  visibleColumns: any
  style?: any
}

const TableRow: React.FC<Props> = (props) => {
  const { rowData, visibleColumns, style } = props

  return (
    <>
      <tr
        {...rowData.getRowProps({
          style,
        })}
      >
        {rowData.cells.map((cell, key) => {
          return (
            <MainTableCell
              key={key}
              {...cell.getCellProps([
                {
                  className: cell.column.className,
                  style: cell.column.style,
                },
              ])}
            >
              {cell.render('Cell')}
            </MainTableCell>
          )
        })}
      </tr>

      {rowData.isExpanded ? (
        <SubComponent isOpen={rowData.isExpanded}>
          <TableCell colSpan={visibleColumns.length}>
            <Content>
              {rowData.original.subComponent.map((item, key) => (
                <Column key={key}>
                  <Line />
                  <Title>
                    <span>{item.title}</span>
                  </Title>
                  <Fields>
                    {item.fields.map((item, key) => (
                      <Field key={key}>
                        <FieldTitle>{item.name}</FieldTitle>
                        <Description>{item.value}</Description>
                      </Field>
                    ))}
                  </Fields>
                </Column>
              ))}
            </Content>
          </TableCell>
        </SubComponent>
      ) : null}
    </>
  )
}

export default TableRow
